export class ListAzureUnassignedNetworkInterfacesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureUnassignedNetworkInterfacesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
